const userGuideIndicesReducers = (state = [], action) => {
    switch (action.type) {
        case "USER_GUIDE_INDICES_INITIAL":
            return {
                nodes: action.nodes,
                toRemove: []
            };
        case "USER_GUIDE_ARTICLE_INITIAL":
            return {
                ...state,
                article: action.article
            };
        case "USER_GUIDE_ARTICLES_INITIAL":
            return {
                ...state,
                articles: action.articles
            };
        case "USER_GUIDE_ARTICLE_LOADING":
            return {
                ...state,
                article: null
            };
        case "USER_GUIDE_INDICES_QUEUE_FOR_REMOVAL":
            return {
                nodes: state.nodes,
                toRemove: [...state.toRemove, action.id]
            };
        case "USER_GUIDE_INDICES_CLEAN_NODES":
            return {
                nodes: state.toRemove.some(v => v === action.id) ? removeUserGuideNodeById(state.nodes, action.id) : state.nodes,
                toRemove: state.toRemove.filter(v => v !== action.id)
            };
        case "USER_GUIDE_INDICES_UNDO":
            return {
                nodes: state.nodes,
                toRemove: state.toRemove.filter(v => v !== action.id)
            };
        case "USER_GUIDE_INDICES_UPDATE":
            return {
                nodes: UpdateUserGuideNode(action.newNode, state.nodes, action.id),
                toRemove: state.toRemove
            };
        case "USER_GUIDE_INDICES_UPDATE_REMOVE_COUNT":
            return {
                nodes: removeUserGuideCount(state.nodes, action.id),
                toRemove: state.toRemove
            };
        case "USER_GUIDE_INDICES_CREATE":
            return {
                nodes: CreateNewUserGuideNode(action.newNode, state.nodes, action.id),
                toRemove: state.toRemove
            };
        default:
            return state;
    }
}

function CreateNewUserGuideNode(newNode, nodes, id) {
    let copy = [];
    if (!id) {
        if (nodes) {
            copy = [
                ...nodes,
                {
                    label: newNode.label,
                    id: newNode.id,
                    icon: newNode.icon,
                    isActive: newNode.isActive,
                    isOpen: false,
                    count: 0,
                    nodes: []
                }
            ];
        } else {
            copy = [
                {
                    label: newNode.label,
                    id: newNode.id,
                    icon: newNode.icon,
                    isActive: newNode.isActive,
                    isOpen: false,
                    count: 0,
                    nodes: []
                }
            ];
        }
    } else {
        nodes.map(node => {
            if (node.id === id) {
                node.nodes = [
                    ...node.nodes,
                    {
                        label: newNode.label,
                        id: newNode.id,
                        icon: newNode.icon,
                        isActive: newNode.isActive,
                        isOpen: false,
                        count: 0,
                        nodes: []
                    }
                ];
            }
            copy.push({
                ...node,
                nodes: CreateNewUserGuideNode(newNode, node.nodes, id)
            });
            return '';
        });
    }
    return copy;
}

function UpdateUserGuideNode(newNode, nodes, id) {
    let copy = [];
    nodes.map(node => {
        if (node.id === id) {
            node = {
                ...node,
                label: newNode.label,
                id: newNode.id,
                icon: newNode.icon,
                isActive: newNode.isActive,
                isOpen: newNode.isOpen,
            };
        }
        copy.push({
            ...node,
            nodes: UpdateUserGuideNode(newNode, node.nodes, id)
        });
        return '';
    });
    return copy;
}

function removeUserGuideNodeById(nodes, id) {
    let copy = [];
    nodes.map(node => {
        if (node.id !== id) {
            copy.push({
                label: node.label,
                id: node.id,
                icon: node.icon,
                isOpen: node.isOpen,
                isActive: node.isActive,
                count: node.count,
                nodes: removeUserGuideNodeById(node.nodes, id)
            });
        }
        return '';
    });
    return copy;
}

function removeUserGuideCount(nodes, id) {
    let copy = [];
    nodes.map(node => {
        if (node.id === id) {
            node = {
                ...node,
                count: node.count - 1,
            };
        }
        copy.push({
            ...node,
            nodes: removeUserGuideCount(node.nodes, id)
        });
        return '';
    });
    return copy;
}

export default userGuideIndicesReducers;